import * as z from 'zod';

import { LoanId, PaymentDueId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const RegenerateStatementPdfEvent = BaseLoanEvent.extend({
  type: z.literal('regenerateStatementPdf'),
  loanId: LoanId,
  paymentDueId: PaymentDueId,
  disableEmail: z.boolean().optional(),
});
export type RegenerateStatementPdfEvent = z.infer<typeof RegenerateStatementPdfEvent>;
